import React from "react";
import { styled, TextField, Button, StandardTextFieldProps, InputAdornment } from "@mui/material";

export interface SearchFieldInterface extends StandardTextFieldProps {
  placeholder?: string;
}

const StyledTextField = styled(TextField)(
  () => ({
    paddingRight: 4,
    paddingTop: 8,
    paddingBottom: 8,
    '& .MuiButton-root': {
      height: 31,
      borderRadius: 13,
      fontSize: 14,
      fontWeight: 400,
      padding: "0px 19px"
    },
    '& .MuiInputBase-root': {
      height: '100%',
    },
    '& .MuiInputAdornment-root': {
      color: "rgba(18, 18, 18, 0.5)"
    }
  }),
);

const SearchFieldWithButton = ({ placeholder = "Search", ...props }: SearchFieldInterface) => {
  return (
    <StyledTextField  {...props} variant="standard" placeholder={placeholder} InputProps={{
      disableUnderline: true,
      endAdornment: <InputAdornment position="end">
        <Button variant="contained">Save</Button>
      </InputAdornment>,
      startAdornment: <InputAdornment position="start">
        <i className="far fa-search"></i>
      </InputAdornment>,
      autoComplete: "off",
    }} />
  )
}

export default SearchFieldWithButton;